import { render, staticRenderFns } from "./BudgetSimulationCard.vue?vue&type=template&id=0472570e&"
import script from "./BudgetSimulationCard.vue?vue&type=script&lang=js&"
export * from "./BudgetSimulationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports